var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadAutomation3P = function SvgFadAutomation3P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 144)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 48)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 112)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m82.096 145.596 13.203-40.42L110.574 112 96.3 153.678zM126 103.342 149.1 130l11.1-12.781-25.866-28.381z"
  }))));
};
export { SvgFadAutomation3P as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-automation-3p.e9436ce5.svg";